(function () {
 'use strict';
 var drawer = document.querySelector('[data-cart-drawer]');
 if (!drawer) return;
 var suggestions = drawer.querySelector('[data-cart-suggestions]'), list = drawer.querySelector('[data-cart-suggestions-list]');
 var controller, sequence = 0, lastKey = '';
 function update(cart) {
  var items = cart.items || [], anchor = items.find(function(item) { return String(item.product_id) === String(cart.focus_product_id); }) || items[0];
  var key = items.map(function(item) { return item.key; }).join(',') + ':' + (anchor && anchor.product_id);
  if (key === lastKey) return;
  lastKey = key;
  sequence += 1;
  var requestSequence = sequence;
  if (controller) controller.abort();
  suggestions.hidden = true; list.replaceChildren();
  if (drawer.dataset.recommendationsEnabled !== 'true' || !anchor) return;
  controller = new AbortController();
  var path = anchor.url.split('?')[0], url = new URL(path,window.location.origin);
  url.searchParams.set('section_id',drawer.dataset.sectionId);
  fetch(url,{signal:controller.signal,credentials:'same-origin'})
  .then(function(response) { if (!response.ok) throw new Error(); return response.text(); })
  .then(function(html) {
   if (requestSequence !== sequence) return;
   var doc = new DOMParser().parseFromString(html,'text/html'), source = doc.querySelector('template[data-cart-suggestions-content]');
   if (!source) return;
   var seen = new Set(items.map(function(item) { return String(item.product_id); }));
   var cards = Array.from(source.content.querySelectorAll('[data-suggestion-product]')).filter(function(card) {
    if (seen.has(card.dataset.suggestionProduct)) return false;
    seen.add(card.dataset.suggestionProduct); return true;
   }).slice(0,4);
   list.replaceChildren.apply(list,cards); suggestions.hidden = cards.length === 0;
  }).catch(function(error) { if (error.name !== 'AbortError' && requestSequence === sequence) lastKey = ''; });
 }
 document.addEventListener('cart:updated',function(event) { update(event.detail); });
 drawer.addEventListener('click',function(event) { if (event.target === drawer) drawer.close(); });
 drawer.addEventListener('change',function(event) {
  var select = event.target.closest('[data-suggestion-variant]');
  if (!select) return;
  var option = select.options[select.selectedIndex], price = select.closest('[data-suggestion-product]').querySelector('[data-suggestion-price]');
  if (price && option) price.textContent = option.dataset.price;
 });
 if (drawer.dataset.recommendationsEnabled === 'true') fetch((window.ShopifyRoutes.root_url || '/') + 'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(response) { if (!response.ok) throw new Error(); return response.json(); }).then(update).catch(function(){});
}());
